// OG image manifest — maps route path to PNG slug
// Generated by scripts/generate-og-images.mjs
// Served from /og/<slug>.png

export const OG_MANIFEST: Record<string, string> = {
  '/': 'home',
  '/about': 'about',
  '/services': 'services',
  '/pricing': 'pricing',
  '/service-areas': 'service-areas',
  '/reviews': 'reviews',
  '/contact': 'contact',
  '/get-a-quote': 'get-a-quote',
  '/quote': 'quote',
  '/residential': 'residential',
  '/recurring': 'recurring',
  '/weekly': 'weekly',
  '/biweekly': 'biweekly',
  '/monthly': 'monthly',
  '/maintenance': 'maintenance',
  '/deep': 'deep',
  '/move-in-out': 'move-in-out',
  '/apply': 'apply',
  '/areas/st-pete': 'areas-st-pete',
  '/areas/tampa': 'areas-tampa',
  '/areas/clearwater': 'areas-clearwater',
  '/areas/largo': 'areas-largo',
  '/areas/dunedin': 'areas-dunedin',
  '/areas/palm-harbor': 'areas-palm-harbor',
  '/areas/safety-harbor': 'areas-safety-harbor',
  '/areas/seminole': 'areas-seminole',
  '/areas/bradenton': 'areas-bradenton',
  '/areas/sarasota': 'areas-sarasota',
  '/book-today': 'book-today',
  '/momwalk-stpete': 'momwalk-stpete',
  '/blog': 'blog',
  '/policies': 'policies',
};
